export default function UAEditMonthlyQuotasCtrl(
  userUuid,
  domainUuid,
  quotas,
  analyticsApi,
  $modalInstance
) {
  this.showError = false
  this.errorMessage = ''
  this.saving = false
  this.quotas = quotas

  this.labelifyQuotaKey = function(key) {
    return key
      .split('_')
      .map(function(w) {
        return w.toUpperCase()[0] + w.substring(1)
      })
      .join(' ')
  }

  this.saveInfo = function(quotas) {
    this.saving = true
    this.showError = false

    analyticsApi.postUserContentAccessReport(userUuid, domainUuid, this.quotas).then(
      function(result) {
        this.saving = false
        $modalInstance.close(result)
      }.bind(this),
      function(reason) {
        this.showError = true
        this.errorMessage = reason
        this.saving = false
      }.bind(this)
    )
  }
}

UAEditMonthlyQuotasCtrl.$inject = [
  'userUuid',
  'domainUuid',
  'quotas',
  'analyticsApi',
  '$uibModalInstance'
]
